import useNavigator from '@hooks/useNavigator'
import NotFoundPage from '@ui/NotFoundPage'
import type React from 'react'

export const NotFound: React.FC = () => {
  const navigate = useNavigator()

  return <NotFoundPage onBack={() => navigate('/')} />
}

export default NotFound
